var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editorContainer",staticClass:"position-absolute cropper-wrap"})
}
var staticRenderFns = []

export { render, staticRenderFns }